// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/SortableItemList.css
// module id = 2084
// module chunks = 3